// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"77be8ee3","453":"1c8a2680"}[chunkId] + ".chunk.js";
};